export default __webpack_public_path__ + "static/media/ce-post3.1b2af9c5.png";